import React from 'react'
import { useSelector } from 'hooks/use-redux'
import { useParams } from 'react-router-dom'
import type { Artist, ArtistId } from 'types/artist'
import type { State } from 'types/redux'
import { getArtist } from '@disco/state-management/selectors/artists'
import ArtistRelatedArtists from 'components/modals/artist/related-artists'

const LibrariesArtistsArtistLinkedArtists = (): React.ReactNode => {
  const params = useParams<{ artistId: string }>()
  const artistId: ArtistId = parseInt(params.artistId!, 10)
  const artist: Artist = useSelector((state: State) =>
    getArtist(state, artistId),
  )
  return artist && <ArtistRelatedArtists artist={artist} />
}

export default LibrariesArtistsArtistLinkedArtists
